import React, { useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import { leagueEventStore } from 'state/league/leagueEvent'
import RequiredDocument from 'pages/Events/Views/Common/Modals/RequiredDocuments/RequiredDocument'

const RequiredDocuments: React.FC = () => {
  const [documentModalVisible, setDocumentModalVisible] =
    useState<boolean>(false)
  const {
    leagueData,
    selectedRequiredDocumentIds,
    setSelectedRequiredDocumentIds,
  } = leagueEventStore(store => ({
    leagueData: store.leagueData,
    selectedRequiredDocumentIds: store.selectedRequiredDocumentIds,
    setSelectedRequiredDocumentIds: store.setSelectedRequiredDocumentIds,
  }))
  return (
    <>
      <div onClick={() => setDocumentModalVisible(true)}>
        <IconsTextNavigation
          iconName="File"
          heading="Required Documents"
          isCompleted={selectedRequiredDocumentIds.length > 0 ? true : false}
        />
      </div>

      {documentModalVisible && (
        <RequiredDocument
          openModal={documentModalVisible}
          closeModal={setDocumentModalVisible}
          organizationId={leagueData.organizationId}
          referenceId={leagueData._id}
          reference="league"
          selectedRequiredDocumentIds={selectedRequiredDocumentIds}
          setSelectedRequiredDocumentIds={setSelectedRequiredDocumentIds}
        />
      )}
    </>
  )
}

export default RequiredDocuments
